var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHydrau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 265,
    viewBox: "0 0 258 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_79)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 1,
    width: 184.555,
    height: 184.555,
    rx: 14,
    transform: "rotate(45 129 1)",
    fill: "#008E81"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 1.70711,
    width: 183.555,
    height: 183.555,
    rx: 13.5,
    transform: "rotate(45 129 1.70711)",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.016 173.263C145.635 173.263 136.012 171.133 125.892 164.684C101.059 148.945 80.3852 164.329 80.1369 164.447C78.1502 165.985 75.2323 165.69 73.6182 163.737C72.004 161.844 72.3144 159.004 74.3632 157.525C74.6115 157.347 100.686 138 131.045 157.288C155.879 173.085 176.552 157.702 176.801 157.525C178.787 155.986 181.705 156.282 183.319 158.235C184.934 160.128 184.623 162.968 182.574 164.447C182.388 164.565 170.716 173.263 153.954 173.263H154.016ZM154.016 142.2C145.635 142.2 136.012 140.07 125.892 133.621C101.059 117.883 80.3852 133.266 80.1369 133.385C78.1502 134.923 75.2323 134.627 73.6182 132.675C72.004 130.781 72.3144 127.941 74.3632 126.462C74.6115 126.285 100.686 106.937 131.045 126.225C155.692 141.905 175.931 127.113 176.801 126.462C178.849 124.924 181.767 125.279 183.319 127.172C184.934 129.065 184.623 131.846 182.574 133.385C182.388 133.503 170.716 142.2 153.954 142.2H154.016ZM154.016 111.138C145.635 111.138 136.012 109.008 125.892 102.559C101.059 86.8205 80.3852 102.145 80.1369 102.322C78.1502 103.86 75.2323 103.565 73.6182 101.612C72.004 99.7188 72.3144 96.8788 74.3632 95.3996C74.6115 95.2221 100.686 75.8746 131.045 95.163C155.879 110.96 176.552 95.518 176.801 95.3996C178.787 93.8613 181.705 94.1571 183.319 96.1096C184.934 98.003 184.623 100.843 182.574 102.322C182.388 102.44 170.716 111.138 153.954 111.138H154.016Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_79",
    x: 0.298998,
    y: 6.799,
    width: 257.402,
    height: 257.402,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_79"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_79",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydrau);
export default __webpack_public_path__ + "static/media/hydrau.f8ca9e445626c2949de352e0378cbf17.svg";
export { ForwardRef as ReactComponent };